const mustBeSwissPhoneNumber = (value) => {
  if (value === '') return true

  const regex = /^(\+?)(\d{2,4})(\s?)(-?)((\(0\))?)(\s?)(\d{2})(\s?)(-?)(\d{3})(\s?)(-?)(\d{2})(\s?)(-?)(\d{2})/
  return value.match(regex) !== null
}

const mustHaveOnePolygon = (rawValue) => {
  if (typeof rawValue === 'undefined' || rawValue === '') return false

  let value = JSON.parse(rawValue)
  if (typeof value.features !== 'undefined') return value.features.length > 0

  return true
}

module.exports = {
  mustBeSwissPhoneNumber,
  mustHaveOnePolygon
}
